/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/bookmark'
export default icon
